// eslint-disable-next-line no-restricted-imports
import { lazy } from 'react';

const pendingReload = new Promise(() => {});

export const lazyWithChunkRecovery = (importModule) => {
  return lazy(() => importModule().then((module) => module ?? pendingReload));
};
